import { post } from '../index';

export const inviteUserByCsv = body => {
  return post('/invites/csv',null, body);
};
